import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { SsoService } from 'src/app/services/sso.service';
import Swal from 'sweetalert2';
import { MemberService } from 'src/app/services/member.service';
import { login } from '../login/login.component';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { AdminService } from '../../services/admin.service';
import { ConfigService } from '../../services/config.service';
@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.css'],
})
export class SsoComponent implements OnInit {
  code: string | null = null;
  errMsg: string = '';

  isLoading: boolean = true;
  siteName: string = '';
  constructor(
    private route: ActivatedRoute,
    private sso: SsoService,
    private router: Router,
    private memberService: MemberService,
    private translate: TranslateService,
    private data: DataService,
    private adminService: AdminService,
    private configService: ConfigService,
  ) {
    this.siteName = this.configService.siteName;
  }

  ngOnInit(): void {

    // check site name
    switch (this.siteName) {
      case 'KKU':
        //  Extract 'code' parameter from the URL after redirect
        this.route.queryParamMap.subscribe((params) => {
          this.code = params.get('code');
          if (this.code) {
            this.getAccessToken(this.code);
          }
        });
        return;
      case 'KMITL':
        console.log('KMITL');
        this.route.queryParamMap.subscribe((params) => {
          const raw = params.get('ssoreturn');
          // decode URI component safely (also treat + as space)
          if (raw) {
            try {
              this.code = decodeURIComponent(raw.replace(/\+/g, ' '));
            } catch (e) {
              // If decode fails, fall back to raw value
              this.code = raw;
            }

            let id = this.sso.decryptKMITL(this.code);
            console.log('id>>>', id);

            this.loginWalai(id);
          }
        });
        return;
      default:
        this.errMsg = this.translate.instant('This username has locked!');
        this.ErrorlogIn(this.errMsg);
        return;
    }


  }

  clickLogin() {
    // Get the 'code' parameter from the URL

    switch (this.siteName) {
      case 'KKU':
        window.location.href = this.sso.getKKULoginLogOutUrl(true);
        break;
      case 'KMITL':
        window.location.href = this.sso.getKMITLLoginLogOutUrl(true);
        break;
      default:
        this.errMsg = this.translate.instant('This username has locked!');
        this.ErrorlogIn(this.errMsg);
        return;
    }


  }


  getAccessToken(code: string): void {
    this.sso.getAccessToken(code).subscribe({
      next: (response) => {
        if (!response.ok) {
          console.error('Error fetching access token:', response.error);
          return;
        } else {
          if (!response.citizenId) {
            console.error('Citizen ID not found in response:', response);
            return;
          }
          this.loginWalai(response.citizenId);
          // You can store the access token in local storage or use it as needed
          // localStorage.setItem('accessToken', response.accessToken);
        }

        // Handle the response, e.g., store the access token
        // localStorage.setItem('accessToken', response.access_token);
      },
      error: (error) => {
        console.error('Error fetching access token:', error);
      }
    }).add(() => {
      this.isLoading = false; // Set loading to false after the request completes
    });
  }

  loginWalai(citizenId: string) {
    this.isLoading = true; // Set loading to true before making the request
    var login: login = {
      username: citizenId,
      password: ''
    }

    this.memberService.userLogin(login, false).subscribe(
      (getData: any) => {

        if (getData) {
          if (getData.length > 0) {
            if (getData[0].LOCKED == 1) {
              this.errMsg = this.translate.instant('This username has locked!');
              this.ErrorlogIn(this.errMsg);
              return;
            } else {
              if (getData[0].USERSTATUS == 2 || getData[0].USERSTATUS == 4) {
                if (getData[0].USERSTATUS == 2) {
                  this.errMsg = this.translate.instant(
                    'This username has expired!'
                  );
                  this.ErrorlogIn(this.errMsg);
                  setTimeout(() => {
                    this.redirectToMain(getData);
                  }, 1000);
                }
                if (getData[0].USERSTATUS == 4) {
                  this.errMsg = this.translate.instant(
                    'This username is retired!'
                  );
                  this.ErrorlogIn(this.errMsg);
                }

                return;
              } else {
                this.redirectToMain(getData);
                return;
              }
            }
          } else {
            this.errorMsg();
          }
        } else {
          this.errorMsg();
        }
      },
      (error) => {
        this.errorMsg();
      }
    ).add(() => {
      this.isLoading = false; // Set loading to false after the request completes
    });
  }
  redirectURL = null;

  redirectToMain(getData: any) {
    this.isLoading = true; // Set loading to false after the request completes
    localStorage.setItem('WALAIcurrentUser', JSON.stringify(getData));
    this.data.updateMemberImg(getData[0].PATHPIC);
    this.data.updateMemberAccount(getData);

    if (this.redirectURL != null) {
      window.location.href = this.redirectURL;
    } else {
      this.router.navigateByUrl('/member');
    }
  }

  ErrorlogIn(msg: string) {
    Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: msg,
      showConfirmButton: false,
      timer: 1500,
    });
  }
  errorMsg() {
    this.ErrorlogIn(this.errMsg);
  }
}
